const collator = new Intl.Collator('en', { numeric: true, sensitivity: 'base' });

/**
 * Ascending sort matching the AC collation: 0-9, ๑-๙, space, aA-zZ (non-case sensitive), ก-ฮ
 */
export const compareTextAsc = (a: string, b: string): number => collator.compare(a || '', b || '');
